/**
 * Reusable tooltip and help copy. Use these constants so messaging stays
 * consistent across tooltips, empty states, and future permissioning UI.
 */

/** Short explanation for share link: purpose, permissions, and optional join. */
export const PUBLIC_LINK_TOOLTIP_COPY =
  'Share your trip with a private link. You control what\'s visible—use the permissions below to show or hide details like itinerary, crew, or notes. Optionally allow viewers to join as guest or member.'

/** Meal plan section: opting in/out of planned meals. */
export const MEAL_PLAN_TOOLTIP_COPY =
  'Choose which planned meals you\'ll be participating in. Opt in when you\'re eating the meal; opt out if you\'re skipping it. Your choices help the group plan headcount and portions.'

/** Generate ingredients: use meal title to get AI-suggested ingredients. */
export const GENERATE_INGREDIENTS_TOOLTIP_COPY =
  'Uses the meal title above to suggest ingredients. The more descriptive the title (e.g. "Dutch Oven Pot Roast with carrots and potatoes"), the closer the list will match what you need. You can edit or add to the list after generating.'

/** Generate trip description: one-sentence seed expanded with Ranger. */
export const GENERATE_TRIP_DESCRIPTION_TOOLTIP_COPY =
  'Enter a single sentence about your trip (destination, vibe, or goal). Ranger expands it into a short description using your trip name and dates when available. The full text appears below so you can edit it before saving.'

/** Crew section: who is going on the trip. */
export const CREW_TOOLTIP_COPY =
  'A summary of who is going on this trip. View crew details, roles, and vehicles here.'

/** Inviting Friends (Find Friends): past trip mates only. */
export const INVITING_FRIENDS_TOOLTIP_COPY =
  'We only show people you\'ve been on a trip with before. Invite from this list to add past trip mates to the crew.'

/** Share link: create link, optional join, permissions. */
export const SHARE_LINK_TOOLTIP_COPY =
  'Create a share link so others can view your trip. You can allow them to join as guest or member, and control what they see with permissions.'

/** Announcements: notify the group; owners only. */
export const ANNOUNCEMENTS_TOOLTIP_COPY =
  'Use announcements for anything you want to notify the group about. Only trip owners can add announcements.'

/** Gear checklist: overview and claiming. */
export const GEAR_CHECKLIST_TOOLTIP_COPY =
  'An overview of gear needed for the trip. Claim items to let everyone know what you\'re bringing—great for coordinating who brings what.'
